"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDBodyToJSON = exports.IDBodyFromJSONTyped = exports.IDBodyFromJSON = void 0;
function IDBodyFromJSON(json) {
    return IDBodyFromJSONTyped(json, false);
}
exports.IDBodyFromJSON = IDBodyFromJSON;
function IDBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
exports.IDBodyFromJSONTyped = IDBodyFromJSONTyped;
function IDBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.IDBodyToJSON = IDBodyToJSON;
